import { Fragment } from 'react'
import HeroBackdrop from './searchHero/HeroBackdrop'
import './searchHero/nomadSearchHero.css'

/** Shared light Nomad shell for moteur search forms (hotels, transferts, circuits, cartes). */
export const nomadSearchFormShell =
  'w-full overflow-visible rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--card)] p-4 pb-6 shadow-[var(--shadow-md)] md:p-5 md:pb-7'

const NomadSearchHero = ({
  breadcrumbs = [],
  title,
  description,
  breadcrumbAria,
  children,
  className = '',
}) => (
  <section
    className={`nomad-search-hero relative mb-8 w-full overflow-visible rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--card)] shadow-[var(--shadow-md)] ${className}`.trim()}
  >
    <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-[var(--radius-lg)] text-[var(--primary)]" aria-hidden>
      <HeroBackdrop />
    </div>

    <div className="relative z-10 w-full px-5 py-7 md:px-8 md:py-9">
      {breadcrumbs.length > 0 ? (
        <nav
          className="mb-3 flex flex-wrap items-center gap-2 text-[0.8125rem] text-[var(--muted-foreground)]"
          aria-label={breadcrumbAria}
        >
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1
            return (
              <Fragment key={`${crumb}-${index}`}>
                <span className={isLast ? 'font-semibold text-[var(--foreground)]' : ''}>{crumb}</span>
                {!isLast ? <span className="text-[var(--muted-foreground)]">/</span> : null}
              </Fragment>
            )
          })}
        </nav>
      ) : null}

      {(title || description) ? (
        <header className="mb-6 w-full">
          {title ? (
            <h1 className="nomad-search-hero__title m-0 text-[clamp(1.75rem,3vw,2.25rem)] font-extrabold leading-tight tracking-tight text-[var(--foreground)]">
              {title}
            </h1>
          ) : null}
          {description ? (
            <p className="mt-2 text-sm leading-relaxed text-[var(--muted-foreground)] md:text-[0.9375rem]">
              {description}
            </p>
          ) : null}
        </header>
      ) : null}

      <div className="w-full">{children}</div>
    </div>
  </section>
)

export default NomadSearchHero
